import { jsx, jsxs } from 'react/jsx-runtime';
import { twMerge } from '@belong/common/twMerge';
import { IconSpinner } from '@belong/icons/dist/IconSpinner';
import { Text } from '../Text/Text.js';

function Spinner({
  showBg = true,
  className,
  text
}) {
  return jsx("div", {
    className: twMerge('absolute top-0 bottom-0 left-0 right-0 flex justify-center items-center z-fullscreen', showBg && 'bg-white-translucent', className),
    children: jsxs("div", {
      className: "flex flex-col justify-center",
      children: [jsx("div", {
        className: "mx-auto",
        children: jsx(IconSpinner, {
          width: 40
        })
      }), text && jsx(Text, {
        children: text
      })]
    })
  });
}

export { Spinner };
